import {useState, useCallback} from 'react';
import { makeStyles, Button, StatusLabel, Divider } from '@ellucian/react-design-system/core';
import { useIntl } from 'react-intl';
import useApplicationForm from './useApplicationForm';
import { CONSTANTS } from '../Helpers/Configuration';
import { spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import { FormattedMessage } from 'react-intl';
import SupplementalItemsUploadDialog from './SupplementalItemsUploadDialog';
import HtmlFormattedMessage from '../HtmlFormattedMessage/HtmlFormattedMessage';

const useStyles = makeStyles({
    name: 'SupplementalItemsMobileRow'
})(() => ({
    mobileItemListItem: {
        display: 'grid',
        gridTemplateRows: '1fr',
        gridTemplateColumns: '1fr 2fr',
        gridGap: spacing40,
    }
}));

const SupplementalItemsMobileRow = props => {
    const intl = useIntl();
    const { classes } = useStyles();
    const {item, handleFormNavigate } = props;
    const { applicationFormStatuses } = CONSTANTS;
    const { previewMode, selectedLocale } = useApplicationForm();
    const { itemTypes } = CONSTANTS.supplementalItems;
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const closeDialog = useCallback(() => {
        setOpenUploadDialog(false);
    }, [openUploadDialog]);

    const handleUploadClick = useCallback(() => {
        setOpenUploadDialog(true);
    }, [openUploadDialog]);
   
    return (
        <>
            <div className={classes.mobileItemListItem}>
                <div className={classes.listItemLabel}><FormattedMessage id="supplementalItemListName" /></div>
                <div>{intl.formatMessage({ id: item.nameId })}</div>
                <div className={classes.listItemLabelRich}><FormattedMessage id="supplementalItemListDescription" /></div>
                <div><HtmlFormattedMessage descriptor={{ id: item.descriptionId }} /></div>
                <div className={classes.listItemLabel}><FormattedMessage id="supplementalItemListRequired" /></div>
                <div><FormattedMessage id={item.required ? 'yes' : 'no'} /></div>
                <div className={classes.listItemLabel}><FormattedMessage id="supplementalItemListStatus" /></div>
                <div>
                    {item.waived &&
                        <StatusLabel
                            text={intl.formatMessage({ id: 'supplementalItemListStatusWaived' })}
                            type={'default'}
                        />
                    }
                    {!item.waived &&
                        <StatusLabel
                            text={intl.formatMessage({ id: item.dateReceived ? 'supplementalItemListStatusReceived' : 'supplementalItemListStatusNotReceived' })}
                            type={item.dateReceived ? 'success' : 'default'}
                        />
                    }
                </div>
                {item.dateReceived &&
                    <>
                        <div className={classes.listItemLabel}><FormattedMessage id="supplementalItemListDateReceived" /></div>
                        <div>{(new Date(item.dateReceived)).toLocaleDateString(selectedLocale, { dateStyle: 'medium' })}</div>
                    </>
                }
                {item.itemType !== itemTypes.display &&
                    <>
                        <div className={classes.listItemLabel}><FormattedMessage id="supplementalItemListActions" /></div>
                        <div>
                            {(item.itemType === itemTypes.upload || item.itemType === itemTypes.suppFormUpload) &&
                                <Button
                                    disabled={previewMode}
                                    onClick={handleUploadClick}
                                    variant="text"
                                >
                                    <FormattedMessage
                                        id="supplementalItemListActionUpload"
                                        values={{
                                            uploaded: Number(0).toLocaleString(selectedLocale),
                                            maxUploads: item.maxUploads ? item.maxUploads.toLocaleString(selectedLocale) : Number(0).toLocaleString(selectedLocale)
                                        }}
                                    />
                                </Button>
                            }
                            {(item.itemType === itemTypes.suppForm || item.itemType === itemTypes.suppFormUpload) &&
                                <Button
                                    disabled={previewMode}
                                    onClick={() => handleFormNavigate(item.supplementalFormId)}
                                    variant="text"
                                >
                                    {item.supplementalFormStatus === applicationFormStatuses.NOTSTARTED &&
                                        <FormattedMessage id="supplementalItemListActionStart" />
                                    }
                                    {item.supplementalFormStatus === applicationFormStatuses.STARTED &&
                                        <FormattedMessage id="supplementalItemListActionEdit" />
                                    }
                                    {item.supplementalFormStatus === applicationFormStatuses.SUBMITTED &&
                                        <FormattedMessage id="supplementalItemListActionView" />
                                    }
                                </Button>
                            }
                        </div>
                    </>
                }
            </div>
            <Divider />
            { openUploadDialog &&
                <SupplementalItemsUploadDialog
                    onClose={closeDialog}
                    itemName={item.nameId}
                    maxUploads={item.maxUploads}
                    fullScreen={true}
                />
            }
        </>
    );
};

export default SupplementalItemsMobileRow;